/**
 * The issue rail's fetch, shared.
 *
 * The rail refetches a project's issues - threads included - whenever polling
 * sees the project change. The issue page listens here rather than making a
 * call of its own, so the two can never show different states of one issue.
 */

const listeners = new Set()

export function publishIssues(projectId, issues) {
	listeners.forEach((listener) => listener(projectId, issues))
}

/** Returns the unsubscribe function, so it can be an effect's cleanup. */
export function subscribeIssues(listener) {
	listeners.add(listener)
	return () => {
		listeners.delete(listener)
	}
}
